import(/* webpackMode: "eager", webpackExports: ["Skeleton"] */ "/home/runner/work/MONADATY/MONADATY/components/skeletons/Skeleton.tsx");
